// extracted by mini-css-extract-plugin
export default {"noteItemContainer":"ActiveMedication_noteItemContainer__6BpLj","medicationContainer":"ActiveMedication_medicationContainer__b5zYm","dosage":"ActiveMedication_dosage__XjMLp"};